<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Produtos e Serviços</label>
    </div>
    <tab-navegacao-produto />
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn
            v-if="isAllowed(6)"
            color="info"
            to="/produto&servico/criar"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="produtos.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="produtos.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title class="produto-servico-lista__titulo">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              small
              class="ml-4 produto-servico-lista__restaurar-colunas"
              @click="restaurarColunasProdutoServico"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left small>mdi-table-column-width</v-icon>
              Restaurar colunas
            </v-btn>
          </template>
          <span>Restaurar larguras padrao</span>
        </v-tooltip>
      </v-card-title>
      <v-data-table
        v-resizable-columns="resizableColumnsOptions"
        :headers="headers"
        :items="filteredList"
        class="elevation-1 produto-servico-lista"
        :loading="loading && produtos.length === 0"
        :loading-text="loadingText"
        :search="search"
        :options.sync="options"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, 20],
        }"
      >
        <template v-slot:top>
          <v-alert
            v-if="carregandoMais"
            dense
            text
            type="info"
            class="ma-4 mb-0"
          >
            Carregando produtos e servicos em partes: {{ produtos.length }} de {{ totalProdutos }} itens recebidos.
          </v-alert>
        </template>
        <template v-slot:item.descricao="{ item }">
          <span class="produto-servico-lista__texto" :title="item.descricao">
            {{ textoComQuebras(item.descricao) }}
          </span>
        </template>
        <template v-slot:item.grupo="{ item }">
          <span class="produto-servico-lista__texto" :title="item.grupo">
            {{ textoComQuebras(item.grupo) }}
          </span>
        </template>
        <template v-slot:item.subGrupo="{ item }">
          <span class="produto-servico-lista__texto" :title="item.subGrupo">
            {{ textoComQuebras(item.subGrupo) }}
          </span>
        </template>
        <template v-slot:item.marca="{ item }">
          <span class="produto-servico-lista__texto" :title="item.marca">
            {{ textoComQuebras(item.marca) }}
          </span>
        </template>
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <!--<template v-slot:header="{ header }">
          <tr class="grey lighten-3">
            <th>
              <v-icon>filter_list</v-icon>
            </th>
            <th v-for="header in headers" :key="header.text">
              <div v-if="filters.hasOwnProperty(header.value)">
                <v-autocomplete
                  flat
                  hide-details
                  multiple
                  attach
                  chips
                  dense
                  clearable
                  :items="columnValueList(header.value)"
                  v-model="filters[header.value]"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 8">
                      <span>
                        {{ item }}
                      </span>
                    </v-chip>
                    <span v-if="index === 8" class="grey--text caption">
                      (+{{ filters[header.value].length - 8 }} others)
                    </span>
                  </template>
                </v-autocomplete>
              </div>
            </th>
          </tr>
        </template>-->
        <template v-slot:item.actions="{ item }">
          <div class="produto-servico-lista__acoes">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="mr-2"
                  @click="editar(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span v-if="isAllowed(6)">Editar</span>
              <span v-else>Ver</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TabNavegacaoProduto from "../../Tabs/TabCadastroProduto";
import { downloadLista } from "../../../services/produtoService";
import { getUserRoles } from "@/services/loginService";

export default {
  name: "listaProdutos",
  data() {
    return {
      loading: false,
      carregandoMais: false,
      totalProdutos: 0,
      tamanhoLote: 1000,
      cargaProdutosId: 0,
      showAtivo: false,
      search: "",
      columnResizeResetKey: 0,
      headers: [
        {
          text: "Id",
          align: "start",
          value: "id",
          width: "4%",
          minWidth: 55,
          class: "produto-servico-lista__col-id",
          cellClass: "produto-servico-lista__col-id",
        },
        { text: "Descrição", value: "descricao", width: "24%", minWidth: 180, class: "produto-servico-lista__col-texto", cellClass: "produto-servico-lista__col-texto" },
        { text: "Código", value: "codigo", width: "8%", minWidth: 100, class: "produto-servico-lista__col-curta", cellClass: "produto-servico-lista__col-curta" },
        { text: "Unidade", value: "unidadeMedida", width: "8%", minWidth: 85, class: "produto-servico-lista__col-curta", cellClass: "produto-servico-lista__col-curta" },
        { text: "Grupo", value: "grupo", width: "11%", minWidth: 110, class: "produto-servico-lista__col-texto", cellClass: "produto-servico-lista__col-texto" },
        { text: "Subgrupo", value: "subGrupo", width: "14%", minWidth: 130, class: "produto-servico-lista__col-texto", cellClass: "produto-servico-lista__col-texto" },
        { text: "Marca", value: "marca", width: "9%", minWidth: 90, class: "produto-servico-lista__col-texto", cellClass: "produto-servico-lista__col-texto" },
        { text: "Departamento", value: "departamento", width: "10%", minWidth: 95, class: "produto-servico-lista__col-curta", cellClass: "produto-servico-lista__col-curta" },
        { text: "Status", value: "ativo", width: "6%", minWidth: 70, class: "produto-servico-lista__col-status", cellClass: "produto-servico-lista__col-status" },
        { text: "Ações", value: "actions", sortable: false, width: "6%", minWidth: 64, class: "produto-servico-lista__col-acoes", cellClass: "produto-servico-lista__col-acoes" },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      filters: {
        descricao: [],
        codigo: [],
        unidadeMedida: [],
        grupo: [],
        subGrupo: [],
        marca: [],
        departamento: [],
      },
    };
  },
  computed: {
    ...mapState("produto", ["produtos"]),
    ...mapState("grupoProduto", ["gruposProduto, subGruposProduto"]),
    ...mapState("marca", ["marcas"]),
    ...mapState("unidadeMedida", ["unidadesMedida"]),
    ...mapState("departamento", ["departamentos"]),
    filteredList() {
      const search = (this.search || "").toLowerCase();
      if (this.showAtivo === false) {
        var newList = this.produtos.filter((p) => {
          return (
            ((p.descricao || "").toLowerCase().includes(search) ||
              (p.codigo || "").toLowerCase().includes(search) ||
              (p.departamento || "").toLowerCase().includes(search) ||
              (p.unidadeMedida || "").toLowerCase().includes(search)) &&
            p.ativo === true
          );
        });
        return newList.filter((d) => {
          return Object.keys(this.filters).every((f) => {
            return (this.filters[f].length < 1 || this.filters[f].includes(d[f]) && f.Ativo === true);
          });
        }).sort( function ( a, b ) { return b.id - a.id; } );
      } else {
        var novaLista = this.produtos.filter((p) => {
          return (
            (p.descricao || "").toLowerCase().includes(search) ||
            (p.codigo || "")
              .toLowerCase()
              .includes(search) ||
            (p.unidadeMedida || "").toLowerCase().includes(search)
          );
        });
        return novaLista.filter((d) => {
          return Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
          });
        }).sort( function ( a, b ) { return b.id - a.id; } );
      }
    },
    loadingText() {
      return this.carregandoMais
        ? "Carregando produtos e servicos em partes..."
        : "Buscando dados...";
    },
    resizableColumnsOptions() {
      return {
        storageKey: "salum:table-columns:produto-servico-lista",
        columns: this.headers,
        resetKey: this.columnResizeResetKey,
      };
    },
  },
  methods: {
    ...mapActions("produto", ["atualizarProdutos", "atualizarProdutosPaginados", "atualizarProduto"]),
    ...mapActions("grupoProduto", ["atualizarGruposProduto", "atualizarSubGruposProduto"]),
    ...mapActions("marca", ["atualizarMarcas"]),
    ...mapActions("unidadeMedida", ["atualizarUnidadesMedida"]),
    ...mapActions("departamento", ["atualizarDepartamentos"]),
    editar(produto) {
      this.atualizarProduto(produto);
      if (this.isAllowed(6)) {
        this.$router.push({
          path: "/produto&servico/editar",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      } else {
        this.$router.push({
          path: "/produto&servico/ver",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      }
    },
    baixarlista() {
      downloadLista();
    },
    textoComQuebras(valor) {
      return String(valor || "").replace(/([/.\\-])/g, "$1\u200B");
    },
    restaurarColunasProdutoServico() {
      this.columnResizeResetKey += 1;
    },
    doAjax() {
      if (!this.gruposProduto || this.gruposProduto.length == 0) {
        this.atualizarGruposProduto();
      }
      if (!this.subGruposProduto || this.subGruposProduto.length == 0) {
        this.atualizarSubGruposProduto();
      }
      if (!this.marcas || this.marcas.length == 0) {
        this.atualizarMarcas();
      }
      if (!this.unidadeMedida || this.unidadeMedida.length == 0) {
        this.atualizarUnidadesMedida();
      }
      if (!this.departamentos || this.departamentos.length == 0) {
        this.atualizarDepartamentos();
      }
    },
    async obter() {
      if (this.$store.getters["produto/getStatusAtualizacaoLista"]) {
        await this.carregarProdutosEmLotes();
      }
      /*const d = new Date();
      let hour = d.getHours();
      if (
        !this.produtos ||
        this.produtos.length == 0 ||
        this.ultimaAtualizacaoLista == null ||
        hour - this.ultimaAtualizacaoLista.getHours() > 0
      ) {
        this.loading = true;
        await this.atualizarProdutos();
        this.ultimaAtualizacaoLista = d;
        this.loading = false;
      }*/
    },
    async carregarProdutosEmLotes() {
      const cargaAtual = ++this.cargaProdutosId;

      this.loading = true;
      this.carregandoMais = true;
      this.totalProdutos = 0;

      try {
        let pagina = 1;
        let total = 0;
        let recebidos = 0;

        do {
          const resultado = await this.atualizarProdutosPaginados({
            pagina,
            tamanhoPagina: this.tamanhoLote,
            limparLista: pagina === 1,
          });

          if (cargaAtual !== this.cargaProdutosId) {
            return;
          }

          total = resultado.total;
          this.totalProdutos = total;
          recebidos += resultado.itens.length;
          pagina += 1;
          this.loading = false;

          await this.$nextTick();
        } while (recebidos < total);
      } finally {
        if (cargaAtual === this.cargaProdutosId) {
          this.loading = false;
          this.carregandoMais = false;
        }
      }
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    columnValueList(val) {
      return this.filteredList.map((d) => d[val]);
    },
  },
  watch: {
    "options.page"(p) {
      this.$router.replace({
        query: { ...this.$route.query, page: String(p) },
      });
    },
    "$route.query.page": {
      immediate: true,
      handler(val) {
        const qPage = parseInt(val, 10);
        const next = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
        if (next !== this.options.page) {
          this.options = { ...this.options, page: next };
        }
      },
    },
  },
  created: function () {
    this.doAjax();
    this.obter();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }

    const qPage = parseInt(this.$route.query.page, 10);
    this.options.page = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
  },
  components: {
    TabNavegacaoProduto,
  },
};
</script>

<style>
.produto-servico-lista__titulo {
  align-items: center;
  flex-wrap: nowrap;
}

.produto-servico-lista__titulo .v-input {
  min-width: 220px;
}

.produto-servico-lista__restaurar-colunas {
  flex: 0 0 auto;
  text-transform: none;
}

.produto-servico-lista table {
  table-layout: fixed;
  width: 100%;
}

.produto-servico-lista th,
.produto-servico-lista td {
  font-size: 13px !important;
  line-height: 1.25;
  padding-left: 6px !important;
  padding-right: 6px !important;
  vertical-align: middle;
  word-break: normal;
}

.produto-servico-lista th {
  white-space: normal;
}

.produto-servico-lista__col-id,
.produto-servico-lista__col-curta,
.produto-servico-lista__col-status,
.produto-servico-lista__col-acoes {
  white-space: normal;
  overflow: visible;
}

.produto-servico-lista__col-id,
.produto-servico-lista__col-status,
.produto-servico-lista__col-acoes {
  text-align: center;
}

.produto-servico-lista__col-acoes {
  white-space: nowrap;
}

.produto-servico-lista__col-acoes .v-icon {
  margin-right: 0 !important;
}

.produto-servico-lista__acoes {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  min-width: 28px;
  white-space: nowrap;
  width: 100%;
}

.produto-servico-lista__col-texto {
  white-space: normal;
  overflow: visible;
}

.produto-servico-lista__texto {
  display: inline;
  white-space: normal;
  overflow-wrap: normal;
  word-break: normal;
}
</style>
